import { cva } from 'class-variance-authority';

export const container = cva(
  [
    'flex',
    'items-center',
    'justify-center',
    'shadow-default',
    'enabled:hover:transition-all',
    'cursor-pointer',
    'disabled:opacity-50 disabled:cursor-not-allowed',
    'rounded-md',
    'w-full',
    'min-w-max',
    'p-1.5',
    'text-xs',
  ],
  {
    variants: {
      variant: {
        primary: ['text-white', 'bg-brand-pure', 'enabled:hover:bg-brand-600'],
        outlined: [
          'text-brand-pure',
          'bg-white',
          'border',
          'border-brand-pure',
        ],
        primarySoft: [
          'text-brand-400',
          'font-semibold',
          'bg-brand-50',
          'enabled:hover:bg-brand-200',
        ],
        secondary: [
          'text-brand-800',
          'bg-white',
          'enabled:hover:bg-brand-100',
          'border',
          'border-neutral-300',
          'shadow',
        ],
        success: [
          'text-neutral-800',
          'bg-sustainability-green-800',
          'enabled:hover:bg-sustainability-green-900',
        ],
        successSoft: [
          'text-sustainability-green-900',
          'bg-sustainability-green-50',
          'enabled:hover:bg-sustainability-green-100',
          'border',
          'border-sustainability-green-300',
        ],
        danger: [
          'text-white',
          'bg-driver-centricity-800',
          'enabled:hover:bg-driver-centricity-900',
        ],
        dangerSoft: [
          'text-driver-centricity-800',
          'bg-driver-centricity-50',
          'enabled:hover:bg-driver-centricity-300',
          'border',
          'border-driver-centricity-300',
        ],
        ghost: [
          'text-neutral-600',
          'bg-white',
          'enabled:hover:bg-brand-100',
          'border',
          'border-neutral-300',
          'shadow',
        ],
      },
      size: {
        xs: ['p-1.5', 'text-xs'],
        small: ['p-2.5', 'text-sm', 'font-medium'],
        medium: ['sm:p-3.5', 'sm:font-semibold'],
        large: ['sm:p-5', 'sm:font-semibold'],
        campaign: ['sm:p-2.5', 'sm:font-semibold', 'p-2'],
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'medium',
    },
  },
);

export const loading = cva(
  [
    'animate-spin',
    'inline-block',
    'w-4',
    'h-4',
    'border-4',
    'border-current',
    'border-t-transparent',
    'rounded-full',
    'absolute',
  ],
  {
    variants: {
      variant: {
        primary: ['text-white'],
        outlined: ['text-brand-pure'],
        primarySoft: ['text-brand-400'],
        secondary: ['text-brand-800'],
        success: ['text-neutral-800'],
        successSoft: ['text-sustainability-green-900'],
        danger: ['text-white'],
        dangerSoft: ['text-driver-centricity-800'],
        ghost: ['text-neutral-600'],
      },
    },
  },
);

export const content = cva(
  ['flex', 'justify-center', 'items-center', 'gap-3'],
  {
    variants: {
      isLoading: {
        true: 'invisible',
        false: 'visible',
      },
    },
  },
);

export const containerIcon = cva(['flex', 'items-center', 'justify-center']);

export const text = cva([
  'block',
  'group-[.flex]:hidden',
  'md:group-[.flex]:block',
]);

export const textDropDown = cva([
  'block',
  'text-neutral-600',
  'text-sm',
  'md:text-base',
  'font-medium',
  'group-[.flex]:hidden',
  'md:group-[.flex]:block',
]);
